import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { InventoryHistoryPageRoutingModule } from './inventory-history-routing.module';

import { InventoryHistoryPage } from './inventory-history.page';

import { TableModule } from 'primeng/table';
import { SalonMonsterLoadMaskModule } from '../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../components/smr-tap-retry/smr-tap-retry.module';
import { MenuButtonComponentModule } from '../components/smr-menu-button/smr-menu-button.module';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    InventoryHistoryPageRoutingModule,
    TableModule,
    SharedModule,
    MenuButtonComponentModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule
  ],
  declarations: [InventoryHistoryPage]
})
export class InventoryHistoryPageModule {}
